export const MODE = {
	FEEDBACK: 'feedback',
	RECORDING: 'recording'
};
